import { format } from 'date-fns';
import { ToastContainer } from "react-toastify";
import Loading from "../../../core/utils/loading";
import PdfViewerModal from '../components/modal-pdf/pdf-viewer-modal';
import { useCodigos } from './hooks/useCodigos';
import Modal from "react-modal";

const Codigos = () => {

    const {
        state,
        data,
        form,
        functions,
        paginador
    } = useCodigos();

    return (
        <>
            <ToastContainer />
            <PdfViewerModal isOpen={data.isOpen} closeModal={() => functions.closeModal()} fileName={data.currentFile} />
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 className="h2">Codigos</h1>
            </div>
            <div className="row">
                <div className="col-md-1"></div>
                <div className="col-md-10">
                    <div className="card border-0 shadow-sm">
                        <div className="card-header border-0">
                            <h3>Generar codigo</h3>
                            <div className="card-options">...</div>
                        </div>
                        <div className="card-body">
                            <form onSubmit={form.handleSubmit(functions.handdleAddCode)} >
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor="archivo_contrato" className="form-label">Contrato</label>
                                        <input {...form.register("archivo_contrato")} className={`form-control ${form.errors.archivo_contrato ? 'is-invalid' : ''}`} type="file" accept=".pdf" id="archivo_contrato" />
                                        <div className="invalid-feedback">
                                            {form.errors.archivo_contrato?.message}
                                        </div>
                                    </div>
                                    <div className="col">
                                        <label htmlFor="codigo" className="form-label">Codigo</label>
                                        <div className="input-group mb-3">
                                            <input {...form.register("codigo", { required: "El codigo es obligatorio" })} placeholder="Codigo formulario" type="text" className={`form-control ${form.errors.codigo ? 'is-invalid' : ''}`} id="codigo" disabled />
                                            <button onClick={functions.handleGenerateCode} className="btn btn-primary btn-outline-secondary" type="button" id="button-addon2" name="Generar Código">
                                                <i className="bi bi-lightning-charge-fill text-white"></i>
                                            </button>
                                            <div className="invalid-feedback">
                                                {form.errors.codigo?.message}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-center mt-4">
                                    <button className="btn btn-primary text-center" type="submit">
                                        Guardar
                                    </button>
                                </div>
                            </form>
                            {data.error && <p style={{ color: 'red' }}>{data.error}</p>}
                        </div>
                    </div>
                </div>
                <div className="col-md-1"></div>
            </div>
            <div className="row mt-5">
                <div className="col-md-12">
                    <div className="card border-0 shadow-sm">
                        <div className="card-header border-0">
                            <h3>Códigos generados</h3>
                        </div>
                        <div className="card-body">
                            {data.error && <p style={{ color: 'red' }}>{data.error}</p>}

                            <fieldset className="border rounded-3 mt-2 p-3">
                                <legend className="float-none w-auto px-3 fw-bold" style={{ "fontSize": "1rem" }} >Filtrar busqueda</legend>
                                <div className='row'>
                                    <div className='col'>
                                        <label className="form-label">Mostrar</label>
                                        <select
                                            {...form.registerSearch("mostrar")}
                                            className='form-select'
                                            onChange={(e) => {
                                                const limit = e.target.value;
                                                paginador.setOptions(prevOptions => ({ ...prevOptions, limit }));
                                            }}
                                        >
                                            <option defaultValue={10} selected>10</option>
                                            <option defaultValue={20}>20</option>
                                            <option defaultValue={50}>50</option>
                                        </select>
                                    </div>
                                    <div className='col'>
                                        <label className="form-label">Codigo</label>
                                        <div className="input-group mb-3">
                                            <button className="btn btn-primary btn-outline-secondary" type="button" name="Buscar codigo">
                                                <i className="bi bi-search text-white"></i>
                                            </button>
                                            <input
                                                {...form.registerSearch("codigo")}
                                                onChange={(e) => {
                                                    const codigo = e.target.value;
                                                    paginador.setOptions(prevOptions => ({ ...prevOptions, codigo }));
                                                }}
                                                placeholder="Codigo formulario"
                                                type="text"
                                                className={`form-control`} id="codigobsucar"
                                            />
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <label className="form-label">Estado</label>
                                        <select
                                            {...form.registerSearch("estado")} className='form-select'
                                            onChange={(e) => {
                                                const estado = e.target.value;
                                                paginador.setOptions(prevOptions => ({ ...prevOptions, estado }));
                                            }}
                                        >
                                            <option value="" selected>--- Seleccione estado ---</option>
                                            <option value={0} defaultValue={0}>Inactivo</option>
                                            <option value={1} defaultValue={1}>Activo</option>
                                            <option value={2} defaultValue={2}>Formulario terminado</option>
                                        </select>
                                    </div>
                                </div>
                            </fieldset>

                            <div>
                                {
                                    state.loading ? (
                                        <Loading />
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table table-striped table-bordered my-4" style={{ fontSize: "13px" }}>
                                                <thead className="table-dark">
                                                    <tr>
                                                        <th className='text-center' scope="col">Codigo</th>
                                                        <th className='text-center' scope="col">Contrato <br />acepado?</th>
                                                        <th className='text-center' scope="col">Estado</th>
                                                        <th className='text-center' scope="col">Form. Terminado</th>
                                                        <th className='text-center' scope="col">Activo</th>
                                                        <th className='text-center' scope="col">Fecha creación</th>
                                                        <th className='text-center' scope="col">
                                                            <i className="bi bi-trash text-white"></i>
                                                        </th>
                                                        {/* <th scope="col" className='text-center'><i className="bi bi-trash"></i></th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data.data.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                {
                                                                    item.archivoContrato ? (
                                                                        <div style={{ display: "flex", alignItems: "center", justifyItems: "center" }}>
                                                                            <a href='#' onClick={() => functions.openModal(item.archivoContrato)} >
                                                                                <i className="bi bi-filetype-pdf text-danger" style={{ fontSize: "22px" }}></i>
                                                                            </a>
                                                                            <i
                                                                                onClick={() => functions.openModalContrato(item)}
                                                                                className="bi bi-box-arrow-up text-success"
                                                                                title='Cambiar contrato'
                                                                                style={{ fontSize: "15px", fontWeight: "bold", cursor: "pointer" }}
                                                                            ></i>
                                                                            <p style={{ margin: "0 0 0 10px" }}>{item.codigo}</p>
                                                                        </div>
                                                                    ) : (
                                                                        <div style={{ display: "flex", alignItems: "center", justifyItems: "center" }}>
                                                                            <i className="bi bi-filetype-pdf" style={{ fontSize: "22px", color: "grey" }} title='No hay contrato'></i>
                                                                            &nbsp;<p style={{ margin: "0 0 0 0px" }}>{item.codigo}</p>
                                                                        </div>
                                                                    )
                                                                }
                                                            </td>
                                                            <td>
                                                                {
                                                                    item.codigosContrato.length > 0 ? (
                                                                        <div class="list-group">
                                                                            <label class="list-group-item d-flex gap-3">
                                                                                <i className=" bi bi-check2-square text-success" style={{ "fontSize": "1.375em" }}></i>
                                                                                <span class="pt-1 form-checked-content">
                                                                                    <strong>Aceptado</strong>
                                                                                    <small class="d-block text-body-secondary">
                                                                                        <i class="bi bi-calendar-event"></i> &nbsp;
                                                                                        {format(new Date(item.codigosContrato[0].fechaRegistro), 'dd/MM/yyyy hh:mm a')}
                                                                                    </small>
                                                                                </span>
                                                                            </label>
                                                                        </div>
                                                                    ) : (
                                                                        <div></div>
                                                                    )
                                                                }
                                                            </td>
                                                            <td>{item.estado}</td>
                                                            <td className='text-center'>
                                                                <div className="form-check form-switch">
                                                                    {
                                                                        item.activo == '2' ? (
                                                                            <input className="form-check-input float-start" type="checkbox" role="switch" defaultChecked={true} onChange={() => functions.handdleMarcarTerminado(item)} />
                                                                        ) : (
                                                                            <input className="form-check-input float-start" type="checkbox" role="switch" onChange={() => functions.handdleMarcarTerminado(item)} />
                                                                        )
                                                                    }
                                                                </div>
                                                            </td>
                                                            <td className='text-center'>
                                                                <div className="form-check form-switch">
                                                                    {
                                                                        item.activo == '1' ? (
                                                                            <input className="form-check-input float-start" type="checkbox" role="switch" defaultChecked={true} onChange={() => functions.handdleEstado(item)} />
                                                                        ) : (
                                                                            <input className="form-check-input float-start" type="checkbox" role="switch" onChange={() => functions.handdleEstado(item)} />
                                                                        )
                                                                    }
                                                                </div>
                                                            </td>
                                                            <td>{format(new Date(item.fechaRegistro), 'dd/MM/yyyy')}</td>
                                                            <td className='text-center text-danger'>
                                                                {
                                                                    item.activo != '2' && item.codigosContrato.length == 0 ? (
                                                                        <i className="bi bi-trash fw-bold" style={{ cursor: 'pointer' }} title='Eliminar codigo' onClick={() => functions.handdleEliminarCodigo(item.codigo)}></i>
                                                                    ) : (<></>)
                                                                }

                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            <div className="d-flex gap-2 justify-content-end">
                                                <button
                                                    className={`btn btn-outline-primary rounded-circle p-0 paginator-button lh-1`}
                                                    type="button"
                                                    onClick={() => paginador.cambiarPagina(paginador.paginador?.limit, 1)}
                                                >
                                                    <i className="bi bi-chevron-double-left"></i>
                                                </button>
                                                <button
                                                    className={`btn btn-outline-primary rounded-circle p-0 paginator-button lh-1`}
                                                    type="button"
                                                    onClick={() => paginador.cambiarPagina(paginador.paginador?.limit, paginador.paginador?.previousPage)}
                                                >
                                                    <i className="bi bi-chevron-left"></i>
                                                </button>
                                                {
                                                    (() => {
                                                        return paginador.itemsPaginator(paginador.paginador?.pages).map((_, currentElementIndex) => {
                                                            if (currentElementIndex >= paginador.inicioPagina && currentElementIndex <= paginador.finPagina) {
                                                                return (
                                                                    <button
                                                                        key={currentElementIndex}
                                                                        className={`btn btn-outline-primary rounded-circle p-0 paginator-button lh-1 ${paginador.paginador?.currentPage == (currentElementIndex + 1) ? "active" : ""}`}
                                                                        type="button"
                                                                        onClick={() => paginador.cambiarPagina(paginador.paginador?.limit, currentElementIndex + 1)}
                                                                    >
                                                                        {currentElementIndex + 1}
                                                                    </button>
                                                                );
                                                            }
                                                        })
                                                    })()
                                                }
                                                <button
                                                    className={`btn btn-outline-primary rounded-circle p-0 paginator-button lh-1`}
                                                    type="button"
                                                    onClick={() => paginador.cambiarPagina(paginador.paginador?.limit, paginador.paginador?.nextPage)}
                                                >
                                                    <i className="bi bi-chevron-right"></i>
                                                </button>
                                                <button
                                                    className={`btn btn-outline-primary rounded-circle p-0 paginator-button lh-1`}
                                                    type="button"
                                                    onClick={() => paginador.cambiarPagina(paginador.paginador?.limit, paginador.paginador?.pages)}
                                                >
                                                    <i className="bi bi-chevron-double-right"></i>
                                                </button>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <Modal
                isOpen={data.isOpenModalContrato}
                onRequestClose={functions.closeModalContrato}
                contentLabel="PDF Viewer"
                style={{
                    content: {
                        width: "50%",
                        height: "50%",
                        margin: "auto",
                        borderRadius: "10px",
                        overflowY: "hidden",
                    },
                    overlay: { zIndex: 1000 }
                }}
            >
                <div className="d-flex justify-content-between border-bottom fw-bold">
                    Cambiar contrato
                    <a href="#" className="" onClick={functions.closeModalContrato} style={{ fontSize: "25px" }}>
                        <i class="bi bi-x text-black"></i>
                    </a>
                </div>
                <div className='mt-5'>
                    <form onSubmit={form.handleSubmitContrato(functions.handdleNewContrato)} >
                        <div className="row">
                            <div className="col">
                                <label htmlFor="archivoContrato" className="form-label">Nuevo Contrato</label>
                                <input {...form.registerContrato("archivoContrato")} className={`form-control ${form.errorsContrato.archivoContrato ? 'is-invalid' : ''}`} type="file" accept=".pdf" id="archivoContrato" />
                                <div className="invalid-feedback">
                                    {form.errorsContrato.archivoContrato?.message}
                                </div>
                            </div>
                        </div>
                        <div className="text-center mt-5">
                            {
                                state.loadingNewContrato ? (
                                    <button className="btn btn-primary" type="button" disabled>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        &nbsp; Actualizando...
                                    </button>
                                ) : (
                                    <button className="btn btn-primary text-center" type="submit">
                                        Actualizar
                                    </button>
                                )
                            }
                        </div>
                    </form>
                </div>
            </Modal>
        </>
    )
}

export default Codigos;